import {auth, AUTH_CONNECTED, init, ScopeType} from '@mail/oauth';
import RPC from 'RPC';

import type {Config, FeedbackCheckResult} from '../types/types';

export default class Api {
	private config: Config;

	constructor(config: Config) {
		this.config = {...config};

		if (!config.localApi) {
			this.config.apiDomain = 'corsapi.imgsmail.ru';
			init({
				clientId: '4e90afb914c14f19a7ac17ceaa28f336',
				scopes: ['mail.api.survey'] as unknown as ScopeType[],
			});
		}
	}

	/**
	 * @param id идентификатор опроса
	 * @returns `true` — если пользователь уже голосовал, `false` — если пользователь еще не голосовал
	 */
	public checkFeedbackVoted(id: string | null): Promise<boolean> {
		const method = 'feedback/nps/check';
		const promise = this.config.localApi
			? this.callLocal<FeedbackCheckResult>(method, {id})
			: this.callOAuth<FeedbackCheckResult>(method, {id});

		return promise.then((body) => {
			return body.voted;
		});
	}

	private async callLocal<T>(method: string, data: Record<string, unknown>): Promise<T> {
		if (!RPC.hasToken()) {
			await RPC.token();
		}

		return RPC.call(method, data).then((response) => {
			if (response.isOK()) {
				return response.body;
			}

			return Promise.reject('RPC.call.fail');
		});
	}

	private async callOAuth<T>(method: string, data: Record<string, unknown>): Promise<T> {
		const accessToken = await this.fetchAccessToken();
		const url = `https://${this.config.apiDomain}/api/v1/${method}`;

		// eslint-disable-next-line compat/compat
		const response = await fetch(url, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({
				...data,
				access_token: accessToken,
			}),
		});

		if (!response.ok) {
			return Promise.reject('fetch.fail');
		}

		const body = await response.json();

		if (body.status !== 200) {
			return Promise.reject('body.status');
		}

		return body.body;
	}

	private async fetchAccessToken(): Promise<string> {
		return new Promise((resolve, reject) => {
			auth(({status, access_token}) => {
				if (status !== AUTH_CONNECTED || !access_token) {
					return reject('oauth');
				}

				resolve(access_token);
			});
		});
	}
}
